import React from "react";
import Image from "next/image";

import HeroButton from "@components/HeroButton";

const GoogleSheetHeader: React.FC = () => {
    return (
        <header className="max-w-6xl mx-auto pt-4  px-4 lg:px-0  bg-white ">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between lg:py-28 pt-0 mt-8">
                <div className="lg:w-1/2 w-full flex flex-col">
                    <div
                        className="text-green-700 bg-green-200 wati-top-green justify-center items-center lg:text-base font-bold flex flex-nowrap w-fit m-auto md:m-0"
                        style={{ padding: "5px 12px", borderRadius: "50px", border: "0.5px solid rgb(9, 146, 80)" }}
                    >
                        <p className=" lg:text-base text-xs">WhatsApp Google Sheets Integration</p>
                        <span className="wa-control-img">
                            <img
                                height="24px"
                                width="24px"
                                src="https://assets.gallabox.com/gb-home/new-zapier/wa-w-whiteborder.svg"
                                alt="white-border-whatsapp-icon"
                                className="ml-2"
                            />
                        </span>
                    </div>
                    <h1 className=" text-gray-600 md:text-4xl text-2xl text-center md:text-left mt-5">WhatsApp Integration with Google Sheets for Smarter Data Management</h1>
                    <p className="lg:py-10 py-4 lg:text-xl font-normal text-center lg:text-left lg:text-gray-700 text-gray-600">
                        Simplify contact management, and build relationships with your customers by meeting them where they are.
                    </p>

                    <HeroButton />
                    <div className="flex gap-4 px-2 lg:px-0 mt-6">
                        {["No credit card required", "No setup fee"].map((each) => {
                            return (
                                <div className="flex items-center gap-1 md:gap-2" key={each}>
                                    <img src="https://assets.gallabox.com/gb-home/content-with-image/grey-tick-circle.svg" alt="Gray checkmark" className="opacity-50" />
                                    <p className="head-points">{each}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="lg:w-1/2 w-full ">
                    <Image src="https://assets.gallabox.com/gb-home/g-sheet/googlesheet-head.png" width={585} height={500} alt="hubsopt" />
                </div>
            </div>
        </header>
    );
};

export default GoogleSheetHeader;
